<template>
  <div class="studentManage">
    <div class="class_info">
      <div class="title">{{$route.query.className}}</div>
      <div class="info_text">
        计划人数：{{$route.query.planStuNum}}&nbsp;人
        <span class="m-l-30">培训时间：{{$route.query.trainStartTime + "&nbsp;至&nbsp;" + $route.query.trainEndTime}}</span>
      </div>
      <div class="info_text h-72" v-if="$route.query.desc">
        选调要求：{{$route.query.desc}}
      </div>
    </div>
    <TransferStudents></TransferStudents>
  </div>
</template>
<script>
import TransferStudents from '@/views/offlineClass/transferStudents/index.vue'
export default {
  name: 'centerSelectClassStudentManage',
  props: {},
  components: {
    TransferStudents
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
  .class_info {
    margin: 0 15px 20px 15px;
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;
    .title {
      font-size: 18px;
      line-height: 28px;
    }
    .info_text {
      font-size: 14px;
      margin-top: 8px;
      line-height: 24px;
    }
    .m-l-30 {
      margin-left: 30px;
    }
    .h-72 {
      max-height: 72px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
</style>